<template>
  <tr>
    <td class="middle">{{ index + 1 }}.</td>

    <w-table-cell :model="item.subjectName">
      <w-textarea :model="item.subjectName" />
    </w-table-cell>

    <w-table-cell :model="item.helpDate">
      <w-datepicker :model="item.helpDate" />
    </w-table-cell>

    <w-table-cell :model="item.plnCost">
      <w-input :model="item.plnCost" />
    </w-table-cell>

    <w-table-cell :model="item.euroCost">
      <w-input :model="item.euroCost" />
    </w-table-cell>

    <w-row-buttons
      class="middle flex-nowrap"
      :model="item"
      :move-up="index != 0"
      :move-down="item.$parent.$value.length - 1 !== index"
    />
  </tr>
</template>

<script>
import components from '@witkac/bootstrap4-components';
// @vuese
// @De Minimis Row
// @Group formStaticComponents
export default {
  components,
  props: {
    // Wartość przekazana do wypelnienia pola w schemacie
    item: { type: Object, required: true },

    // Indeks
    index: { type: Number, required: true }
  }
};
</script>
